import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { creditorConstant } from "../constants/constants";
class CreditorStore extends EventEmitter {
    constructor() {
        super();
        this.creditors = [];
    }
    getAll() {
        return this.creditor;
    }

    handleAction(action) {
        switch (action.type) {
            case creditorConstant.CREDITOR_CREATED: {
                const { creditor } = action;
                this.creditors.push(creditor);
                this.emit(creditorConstant.CREDITOR_CREATED, `creditor  created successfully.`);
                this.emit(creditorConstant.CREDITOR_STORE_CHANGE);
                break;
            }
            case creditorConstant.CREDITOR_CREATION_FAILED: {
                this.emit(creditorConstant.CREDITOR_CREATION_FAILED, action.msg);
                break;
            }
            case creditorConstant.FETCHED_ALL_CREDITOR: {

                this.creditors = action.data;
                this.emit(creditorConstant.CREDITOR_STORE_CHANGE);
                break;
            }
            case creditorConstant.CREDITOR_FETCH_FAILED: {
                this.emit(creditorConstant.CREDITOR_FETCH_FAILED, action.msg);
                break;
            }
            case creditorConstant.UPDATE_CREDITOR: {
                this.emit(creditorConstant.UPDATE_CREDITOR, action.data.msg);
                break;
            }
            case creditorConstant.UPDATE_CREDITOR_CREATION_FAILED: {
                this.emit(creditorConstant.UPDATE_CREDITOR_CREATION_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const creditorStore = new CreditorStore();
dispatcher.register(creditorStore.handleAction.bind(creditorStore));
export default creditorStore;


// WEBPACK FOOTER //
// ./src/jsx/store/creditor-store.jsx